import { generateQueryKey } from 'query';

export const getReleaseNotesQueryKey = (params: { limit: number }) => generateQueryKey(['release-notes', params]);
